// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__DaU26","content":"RecentSearches_content__1rGPg"};